import { render, staticRenderFns } from "./Policy_page.vue?vue&type=template&id=475a0b2c&scoped=true&"
import script from "./Policy_page.vue?vue&type=script&lang=js&"
export * from "./Policy_page.vue?vue&type=script&lang=js&"
import style0 from "./Policy_page.vue?vue&type=style&index=0&id=475a0b2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475a0b2c",
  null
  
)

export default component.exports